import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import TextField from '../components/TextField';
import Snackbar from '../components/Snackbar';
import Button from '../components/Button';
import Wave from '../../static/biz-professional/ai-generated-8326626_1280.jpg';


function ProductCTA() {
  const [open, setOpen] = React.useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container component="section" sx={{ mt: 20, display: 'flex' }}>
      <Grid container>
        <Grid item xs={12} md={6} sx={{ zIndex: 1 }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              bgcolor: 'white',
              py: 10,
              px: 3,
              border: '2px solid', // You can adjust the border width
              borderColor: 'primary.main', // Change this to your desired border color
            }}
          >
            <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400 }}>
              <Typography variant="h4" component="h2" gutterBottom>
                Our Vision
              </Typography>
              <Typography variant="h5">
              </Typography>
              <Typography variant="h5" sx={{ fontSize: 19 }}>
                ビジネスの場にいると、極めて優秀な人であっても（コンテンツとしては素晴らしい成果を出す能力があっても）それを伝える能力が低いが故に
                マネジメントからは評価されていない方々が数多くいます。一方で、ソフトスキルとして語られがちなプレゼンテーションスキルは実は体系的な理論が存在していますし、
                その基本を学習するだけで飛躍的に活躍できる可能性があるのです。<br />　<br />
                また、本サイトではプレゼンテーションという文脈でその理論と実践的なコツをお伝えすることを主たる目的にしていますが、
                そのスキルはプレゼンテーションに留まらず、種々のマネジメントにおいても役立つことでしょう。<br />　<br />
                本来評価を受けるべき”優秀な人”がより高い評価を受けるとともに、
                数多くの組織が社会に対してより本質的な価値を届けるようになることが我々の願いです。
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ display: { md: 'block', xs: 'none' }, position: 'relative' }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: -67,
              left: -67,
              right: 0,
              bottom: 0,
              width: '100%',
              background: 'url(/static/themes/onepirate/productCTAImageDots.png)',
            }}
          />
          <Box
            component="img"
            src={Wave}
            alt="call to action"
            sx={{
              position: 'absolute',
              top: -70,
              left: -28,
              right: 0,
              bottom: 0,
              width: '100%',
              maxWidth: 600,
            }}
          />
        </Grid>
      </Grid>
      <Snackbar
        open={open}
        closeFunc={handleClose}
        message="We will send you our best offers, once a week."
      />
    </Container>
  );
}

export default ProductCTA;
